import { render, staticRenderFns } from "./PerformanceScoreSetup.vue?vue&type=template&id=9ca605ce&scoped=true"
import script from "./PerformanceScoreSetup.vue?vue&type=script&lang=js"
export * from "./PerformanceScoreSetup.vue?vue&type=script&lang=js"
import style0 from "./PerformanceScoreSetup.vue?vue&type=style&index=0&id=9ca605ce&prod&scoped=true&lang=css"
import style1 from "./PerformanceScoreSetup.vue?vue&type=style&index=1&id=9ca605ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca605ce",
  null
  
)

export default component.exports